(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('loggerFactory', loggerFactory);

    loggerFactory.$inject = ['$log'];
    function loggerFactory($log) {
        var slice = Array.prototype.slice;

        return function loggerFactory(category) {
            var logger = {};
            angular.forEach($log, createMethod);
            return logger;

            function createMethod(value, key) {
                logger[key] = method;

                function method(message) {
                    return value.apply($log, [category + ': ' + message].concat(slice.call(arguments, 1)));
                }
            }
        }
    }
})();